import { useCart } from "../../shop/cartStore";
import { IconBag } from "./ShopIcons";

/** Nav entry to the webshop; on the webshop page itself it opens the cart instead. */
function CartNavButton({ t, lang, onOpenCart }) {
  const { count } = useCart();
  const label = count > 0 ? t.cartCount(count) : t.nav;
  const content = (
    <>
      <IconBag className="cart-nav-icon" />
      <span className="cart-nav-text">{onOpenCart ? t.cartLabel : t.nav}</span>
      {count > 0 ? (
        <span className="cart-nav-badge" aria-hidden="true">
          {count}
        </span>
      ) : null}
    </>
  );

  if (onOpenCart) {
    return (
      <button type="button" className="cart-nav" onClick={onOpenCart} aria-label={label}>
        {content}
      </button>
    );
  }

  return (
    <a className="cart-nav" href={`/webshop?lang=${lang}`} aria-label={label}>
      {content}
    </a>
  );
}

export default CartNavButton;
